import { useQuery } from 'react-query';
import { getUserId } from '../../../DefaultService';
import { IPaginationParams } from '../../../types';
import {
  getAllRecognitionsByLicenseAsync,
  getAllRecognitionsByLicenseCountAsync,
} from '../../index';
import { IRecognitionFilterParams } from '../../types';

const USER_ID = getUserId();

export const RECOGNITION_KEYS = {
  ALL: 'recognitions',
  LIST: 'list',
  COUNT: 'count',
};

export const useGetAllRecognitionsByLicenseQuery = (
  pagination: IPaginationParams,
  filter: IRecognitionFilterParams,
) => {
  return useQuery(
    [RECOGNITION_KEYS.ALL, RECOGNITION_KEYS.LIST, pagination, filter],
    async () => {
      return getAllRecognitionsByLicenseAsync(pagination, filter);
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60, 
    }
  );
};

export const useGetAllRecognitionsByLicenseCountQuery = (
  filter: IRecognitionFilterParams,
) => {
  return useQuery(
    [RECOGNITION_KEYS.ALL, RECOGNITION_KEYS.COUNT, filter],
    () => getAllRecognitionsByLicenseCountAsync(filter),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};

// TODO: Hooks antigos, mantidos por enquanto, mas no futuro refatorar as telas que os utilizam para os hooks mais modernos
export const useGetAllRecognitionsByLicenseAsync = (
  pagination: IPaginationParams,
  filter: IRecognitionFilterParams,
) =>
  useQuery(
    [`recognition${pagination.pageNumber}`, pagination, USER_ID],
    async () => {
      // 🔐 garante Firebase autenticado

      return getAllRecognitionsByLicenseAsync(pagination, filter);
    },
    {
      keepPreviousData: true,
      staleTime: 1000 * 60,
    }
  );

export const useGetAllRecognitionsByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: IRecognitionFilterParams,
) =>
  useQuery([`recognitionCount${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllRecognitionsByLicenseCountAsync(filter),
  });

